import { styled } from '@mui/material/styles';
import { Box, Table, TableCell, TableContainer, TableHead, TableRow, Typography, Button, TextField, Tabs, Tab } from '@mui/material';

export const PageWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: '#F8F9FA',
  minHeight: '100vh',
}));

export const SummaryCardsContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: theme.spacing(3),
  marginBottom: theme.spacing(4),
}));

export const SummaryCard = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: '12px',
  padding: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
}));

export const IconWrapper = styled(Box)<{ bgcolor?: string }>(({ bgcolor }) => ({
  width: '48px',
  height: '48px',
  borderRadius: '8px',
  backgroundColor: bgcolor || '#F0F0F0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: '16px',
}));

export const CardInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const CardTitle = styled(Typography)({
  fontSize: '14px',
  color: '#666',
  fontWeight: 500,
});

export const CardValue = styled(Typography)({
  fontSize: '24px',
  fontWeight: 700,
  color: '#333',
  marginTop: '4px',
});

export const MainContentContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: '12px',
  padding: theme.spacing(3),
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
}));

export const ContentHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
}));

export const SectionTitle = styled(Typography)({
  fontSize: '18px',
  fontWeight: 700,
  color: '#333',
});

export const ActionsGroup = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
}));

export const SearchField = styled(TextField)({
  width: '320px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    height: '36px',
    backgroundColor: '#fff',
    '& fieldset': {
      borderColor: '#E0E0E0',
    },
    '&:hover fieldset': {
      borderColor: '#5E8E7E',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#5E8E7E',
    },
  },
  '& .MuiInputBase-input': {
    padding: '8px 14px',
    fontSize: '13px',
  },
});

export const CreatePlanButton = styled(Button)({
  textTransform: 'none',
  backgroundColor: '#5E8E7E',
  color: '#fff',
  borderRadius: '8px',
  padding: '6px 16px',
  height: '36px',
  fontSize: '13px',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: '#4A7A6A',
  },
});

export const StyledTabs = styled(Tabs)({
  borderBottom: '1px solid #E0E0E0',
  marginBottom: '20px',
  '& .MuiTabs-indicator': {
    backgroundColor: '#5E8E7E',
  },
});

export const StyledTab = styled(Tab)({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  minWidth: 'auto',
  marginRight: '24px',
  padding: '12px 0',
  color: '#666',
  '&.Mui-selected': {
    color: '#5E8E7E',
  },
});

export const TableWrapper = styled(TableContainer)({
  borderRadius: '8px',
  overflow: 'hidden',
});

export const SubscriptionTable = styled(Table)({
  minWidth: 650,
});

export const SubscriptionTableHead = styled(TableHead)({
  '& th': {
    backgroundColor: '#5E8E7E',
    color: '#fff',
    fontWeight: 600,
    fontSize: '13px',
    padding: '12px 16px',
    borderBottom: 'none',
  },
});

export const SubscriptionTableRow = styled(TableRow)({
  '&:nth-of-type(even)': {
    backgroundColor: '#F9FBF9',
  },
  '&:hover': {
    backgroundColor: '#F0F5F2',
  },
});

export const SubscriptionTableCell = styled(TableCell)({
  fontSize: '13px',
  padding: '16px',
  color: '#444',
  borderBottom: '1px solid #F0F0F0',
});

export const StatusBadge = styled(Box)<{ status: string }>(({ status }) => ({
  padding: '4px 12px',
  borderRadius: '4px',
  fontSize: '12px',
  fontWeight: 600,
  display: 'inline-block',
  backgroundColor: status === 'Active' ? '#E8F5E9' : '#F5F5F5',
  color: status === 'Active' ? '#2E7D32' : '#757575',
}));

export const ActionIcon = styled(Box)<{ color?: string }>(({ color }) => ({
  cursor: 'pointer',
  color: color || '#5E8E7E',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    opacity: 0.8,
  },
}));
